import { Col, Divider, Row, Typography } from "antd";
import { animalPriceCrudApi } from "../client/EntityApi";
import {
  getAnimalPriceCPColumns,
  getAnimalPriceCPFormItems,
} from "../components/crud/AnimalPriceCPComponents";
import CrudTable from "../core/component/crud/CrudTable";
import { useEffect, useState } from "react";
import { otherApi } from "../core/client/BaseEntityApi";

const { Text } = Typography;

const animalLabels = {
  pregnant: "SAĞMAL GEBE HAYVAN",
  seminated: "SAĞMAL TOHUMLU HAYVAN",
  nonPregnant: "SAĞMAL BOŞ HAYVAN",
  fresh: "FRESH HAYVAN SAYISI",
  dry: "ERKEN KURU",
  closeup: "CLOSEUP (SON 21)",
  fcalf: "DİŞİ BUZAĞI",
  mcalf: "ERKEK BUZAĞI",
  msteer: "ERKEK DANA",
  msteer2: "ERKEK DANA 2",
  msteer3: "ERKEK DANA 3",
  bull: "BOĞA",
  bull2: "BOĞA 2",
  bull3: "BOĞA 3",
  bull4: "BOĞA 4",
  bull5: "BOĞA 5",
  bull6: "BOĞA 6",
  bull7: "BOĞA 7",
  pheifer: "GEBE DÜVE",
  sheifer: "TOHUMLU DÜVE",
  heifer: "BOĞAALTI DÜVE",
  fsteer: "DİŞİ DANA",
} as any;

const AnimalPriceCrudPage = () => {
  const [months, setMonths] = useState([]);

  useEffect(() => {
    otherApi.constants().then((response) => setMonths(response["months"]));
  }, []);

  return (
    <>
      <CrudTable
        entityLabel="Hayvan Fiyat"
        api={animalPriceCrudApi}
        hideSearchBar
        columns={getAnimalPriceCPColumns(months)}
        addFormItems={getAnimalPriceCPFormItems()}
        editFormItems={getAnimalPriceCPFormItems()}
        expandable={{
          expandedRowRender: (record: any) => (
            <div style={{ background: "#f5f5f5", padding: 24, maxWidth: 400 }}>
              <Row style={{ fontWeight: 600 }}>
                <Col span={16}>Hayvan Grubu</Col>
                <Col span={8} style={{ textAlign: "right" }}>
                  Birim Çarpanı
                </Col>
              </Row>

              <Divider style={{ margin: "8px 0 16px" }} />

              {Object.keys(animalLabels).map((key) => (
                <Row key={key} style={{ marginBottom: 12 }}>
                  <Col span={16}>
                    <Text>{animalLabels[key]}</Text>
                  </Col>

                  <Col span={8} style={{ textAlign: "right" }}>
                    <Text>{Number(record.animalPrice[key] || 0)}</Text>
                  </Col>
                </Row>
              ))}
            </div>
          ),
        }}
        setEditFields={(row) => {
          const { month, year, animalPrice } = row;
          return { month, year, ...animalPrice };
        }}
        beforeAddOperation={(data) => {
          const { month, year, ...animalPrice } = data;
          return { month, year, animalPrice };
        }}
        beforeEditOperation={(data) => {
          const { month, year, ...animalPrice } = data;
          return { month, year, animalPrice };
        }}
      />
    </>
  );
};

export default AnimalPriceCrudPage;
